import 'ng-sortable';

import offerRoutes from './offer.routes';

import offerListController from './controllers/offer.list.controller';
import offerSaveController from './controllers/offer.save.controller';
import offerFormController from './controllers/offer.form.controller';
import offerPeriodFormController from './controllers/offer.period.form.controller';

import offerListComponent from './components/offer.list.component';
import offerSaveComponent from './components/offer.save.component';
import offerFormComponent from './components/offer.form.component';
import offerPeriodFormComponent from './components/offer.period.form.component';

import offerService from './services/offer.service';

let offerModule = angular.module('spabooker.offer', [ 'spabooker.base', 'as.sortable' ])
  .config(offerRoutes)

  .controller('offerListController', offerListController)
  .controller('offerSaveController', offerSaveController)
  .controller('offerFormController', offerFormController)
  .controller('offerPeriodFormController', offerPeriodFormController)

  .component('offerList', offerListComponent)
  .component('offerSave', offerSaveComponent)
  .component('offerForm', offerFormComponent)
  .component('offerPeriodForm', offerPeriodFormComponent)

  .factory('offerService', offerService)
;

export default offerModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/index.js